export default function TemplateConfirmationModal({
  isOpen,
  editUrl,
  onClose,
  onContinue,
}) {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" aria-hidden="false">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow-sm border-0 rounded-4">
            <div className="modal-header">
              <h5 className="modal-title fs-5">This is an unedited template.</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body">
              <p>Are you sure you want to schedule it before customizing?</p>
            </div>

            <div className="modal-footer">
              <a
                href={editUrl || "#"}
                target="_blank"
                rel="noreferrer"
                className="btn btn-secondary edit"
              >
                Edit
              </a>

              <button
                type="button"
                className="btn btn-primary continue"
                onClick={onContinue}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show" onClick={onClose}></div>
    </>
  );
}